import type { ReactNode } from "react";
import { usePathname, useRouter } from "@/i18n/navigation";

/**
 * A link to a section of the landing page ("#why", "#features", ...). A bare
 * "#why" link only works on the landing page itself — from the contact or
 * legal pages it did nothing — so off the landing page this goes there first,
 * and the landing page scrolls to the section once it has rendered.
 */
export function SectionLink({ section, className, children }: { section: string; className?: string; children: ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();

  return (
    <a
      href={`#${section}`}
      className={className}
      onClick={(event) => {
        event.preventDefault();
        if (pathname === "/") {
          document.getElementById(section)?.scrollIntoView({ behavior: "smooth", block: "start" });
          history.replaceState(history.state, "", `#${section}`);
        } else {
          router.push(`/#${section}`);
        }
      }}
    >
      {children}
    </a>
  );
}
